import React from 'react'
// libs
import styled from 'styled-components'
// components
import InputLabel from 'components/FormElements/components/InputLabel'
// themes
import { colors } from 'themes'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  vertical-align: top;
`

const TruncatedText = styled.div`
  border-bottom: 1px solid ${colors.gray300};
  font-size: 16px;
  height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

interface Props {
  label: string
  truncated: string
}

const TruncatedInput: React.FC<Props> = ({ label, truncated }) => {
  return (
    <Wrapper>
      <InputLabel shrink>{label}</InputLabel>
      <TruncatedText>{truncated}</TruncatedText>
    </Wrapper>
  )
}

export default TruncatedInput
